'use strict';

module.exports = require('./src/');



// WEBPACK FOOTER //
// ./_rc-select-7.5.0/index.js